<template>
  <div class="box">
    <leave-tile
      v-for="leave in docs"
      :key="leave._id"
      :leave="leave"
    ></leave-tile>
  </div>
</template>
<script>
import LeaveTile from "./leave-tile";
export default {
  components: { LeaveTile },
  computed: {
    docs() {
      let component = this;
      return component.$store.getters["leave/docs"];
    }
  },
  mounted() {
    let component = this;
    component.$store.dispatch("leave/index");
  }
};
</script>
